<template>
    <div style="max-width: 1200px;" class="mx-auto bullet-points">
        <div class="my-4 text-center font-weight-medium">Below are some of the flexible features and benefits of the FHA
            insured
            reverse mortgage.
            Without FHA insurance, many of these benefits would not be available.
        </div>

        <div class="my-4">
            <h3>Cash Flow</h3>
            <ul>
                <li>
                    No mandatory principal or interest payments.
                </li>
                <li v-if="isABD">
                    Ability to re-draw voluntary payments.
                </li>
            </ul>
        </div>

        <div v-if="isAB" class="my-4">
            <h3>Line of Credit</h3>
            <ul>
                <li>
                    The lender cannot arbitrarily cancel or suspend access to the line of credit.
                </li>
                <li>
                    Your line of credit growth rate is initially estimated to be {{
                        formatPercentage(textValues.initialLineOfCreditGrowth.hecmMonthlyARM) }} For as
                    long as you have the reverse mortgage, the minimum growth rate is estimated to be {{
                        formatPercentage(textValues.annualMortgageInsuranceRate.hecmMonthlyARM +
                            textValues.margin.hecmMonthlyARM) }} and the maximum growth rate is estimated to be
                    {{ formatPercentage(textValues.capOnInterestRate.hecmMonthlyARM +
                        textValues.annualMortgageInsuranceRate.hecmAnnualArm) }}.
                </li>
            </ul>
        </div>

        <div v-if="isAB" class="my-4">
            <h3>Annuity style payments</h3>
            <ul>
                <li>
                    Funds available in the line of credit can be converted to monthly payments to the
                    borrower(s). And those monthly payments can be stopped at any time, thus 'recharging' the line of
                    credit.
                </li>
            </ul>
        </div>

        <div v-if="isABD" class="my-4">
            <h3>Voluntary payments from the borrower.</h3>
            <ul>
                <li>
                    Payments received from the borrower will (a) be added to the line of credit and (b) applied to the
                    outstanding loan balance.
                </li>
            </ul>
        </div>

        <div class="my-4">
            <h3>Important facts for borrowers, spouses and heirs.</h3>
            <ul>
                <li>
                    Borrowers have no personal responsibility to repay the reverse mortgage and there is no recourse to
                    the
                    borrowers' estate or heirs.
                </li>
                <li>
                    The residential property is the only collateral.
                </li>
                <li>
                    Title can be held in a trust, provided it meets FHA and lender guidelines.
                </li>
                <li>
                    The process for heirs to repay the reverse mortgage via a sale of the property or refinancing the
                    reverse mortgage is fully transparent.
                </li>
                <li>
                    The end date of the reverse mortgage is the last borrower's 150th birthday.
                </li>
                <li>
                    Protections are in place for spouses who were younger than 62 and
                    living in the home when the reverse mortgage is created, provided
                    the spouse remains married to the borrower and continues to live in
                    the home for the duration of the reverse mortgage.
                </li>
                <li>
                    Borrowers are required to annually certify they occupy the home as
                    their primary residence, maintain the home to meet FHA health and
                    safety standards, and pay property taxes, homeowner’s insurance
                    and HOA dues (if applicable) on a timely basis.
                </li>
                <li>
                    If borrowers do not meet the obove obligations, a default on the loan
                    may be called and access to the line of credit (if applicable) could be
                    suspended. Other actions may be taken by the lender or FHA (if
                    applicable).
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import helpers from '../../helpers';

export default {
    methods: {
        formatPercentage: helpers.formatPercentage,
    },
    computed: {
        currentScenarioTitle() {
            return this.$store.state.scenarioData.scenario;
        },
        allScenariosTitles() {
            return this.$store.state.scenarioData.allScenarioTitles;
        },
        isAB() {
            return this.currentScenarioTitle === this.allScenariosTitles.scenarioATitle
                || this.currentScenarioTitle === this.allScenariosTitles.scenarioBTitle;
        },
        isABD() {
            return this.currentScenarioTitle === this.allScenariosTitles.scenarioATitle
                || this.currentScenarioTitle === this.allScenariosTitles.scenarioBTitle
                || this.currentScenarioTitle === this.allScenariosTitles.scenarioData;
        },
        textValues() {
            const {
                initialLineOfCreditGrowth,
                margin,
                annualMortgageInsuranceRate,
                capOnInterestRate,
            } = this.$store.state.scenarioData.currentScenarioData.finalValues.otherValues;

            return {
                initialLineOfCreditGrowth,
                margin,
                annualMortgageInsuranceRate,
                capOnInterestRate,
            }
        }
    },
};
</script>

<style scoped></style>
